module.exports = __webpack_public_path__ + "media/theme/sample-card__mobage-16d2ce9a.jpg";